import React__default from 'react';
import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';
import CircularProgress from '../../../../../node_modules/@mui/material/CircularProgress/CircularProgress.mjs';

const StyledCircularProgress = styled(CircularProgress)(({ theme })=>({
        color: theme.styleConfig.colors.primary
    }));
const PageLoadingIndicator = ()=>{
    return /*#__PURE__*/ React__default.createElement("div", {
        style: {
            height: '100%',
            minHeight: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React__default.createElement(StyledCircularProgress, null));
};

export { PageLoadingIndicator };
//# sourceMappingURL=PageLoadingIndicator.mjs.map
